import { CurrencyPipe } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Faktura } from '@store/models';
import { localCurrencyToNumber } from 'app/shared/currency';

@Component({
    selector: 'app-change-currency',
    templateUrl: './change-currency.component.html',
    standalone: false
})
export class ChangeCurrencyComponent {

    @Input() fakturaValuta: Partial<Faktura>;
    currencies = [
        {valuta: 'DKK', valutaKurs: 1},
        {valuta: 'EUR', valutaKurs: 7.45}
    ];

    @ViewChild('valuta') valutaRef: ElementRef;
    @ViewChild('valutaKurs') valutaKursRef: ElementRef;

    constructor(
        private modal: NgbActiveModal,
        private currencyPipe: CurrencyPipe
    ) { }

    onCurrencyChange() {
        const newFakturaValuta: Partial<Faktura> = {
            valuta: this.valutaRef.nativeElement.value,
            valutaKurs: localCurrencyToNumber(this.valutaKursRef.nativeElement.value)
        };
        this.modal.close(newFakturaValuta);
    }

    onCancel() {
        this.modal.close(null);
    }

    onCurrencySelect(fakturaValuta: string) {
        const newValutaKurs = this.currencies.find(c => c.valuta === fakturaValuta).valutaKurs;
        this.valutaKursRef.nativeElement.value = this.currencyPipe.transform(newValutaKurs, 'DKK', '', '1.2-2', 'da');
    }

}
